import { render, staticRenderFns } from "./DisplayInputs.vue?vue&type=template&id=fb1181dc&"
import script from "./DisplayInputs.vue?vue&type=script&lang=js&"
export * from "./DisplayInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports